import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Layouts from "../../config/layouts/Layouts";
import NavbarComponent from "../navbar/Navbar";
import Footer from "../footer/Footer";
import { getDateLocale } from "../../utils/locale";

function PolicyPage({ title, children }) {
    const { t } = useTranslation();
    const updatedAt = new Date().toLocaleDateString(getDateLocale(), {
        year: "numeric",
        month: "long",
        day: "numeric",
    });

    return (
        <Layouts>
            <header className="shrink-0">
                <NavbarComponent />
            </header>

            <main className="flex-1 bg-em-bg px-5 pb-[calc(5rem+var(--em-footer-h))] pt-32 sm:px-8 sm:pt-36 md:pt-40">
                <div className="mx-auto max-w-3xl">
                    <h1 className="text-3xl font-bold tracking-tight text-em-text sm:text-4xl">
                        {title}
                    </h1>
                    <p className="mt-2 text-sm text-em-muted">
                        {t("policyPage.updatedAt", { date: updatedAt })}
                    </p>

                    <div className="mt-10 space-y-10">{children}</div>

                    <div className="mt-14">
                        <Link
                            to="/"
                            className="inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-em-vivid to-em-vivid2 px-8 py-3.5 text-sm font-semibold text-em-ink shadow-lg shadow-em-vivid/25 transition hover:opacity-95"
                        >
                            {t("policyPage.backHome")}
                        </Link>
                    </div>
                </div>
            </main>

            <Footer />
        </Layouts>
    );
}

export function PolicySection({ title, children }) {
    return (
        <section className="space-y-3">
            <h2 className="text-xl font-semibold text-em-text">{title}</h2>
            <div className="space-y-3 leading-relaxed text-em-soft [&_a]:text-em-accent [&_a:hover]:text-em-accent2 [&_li]:ml-5 [&_li]:list-disc [&_strong]:text-em-text [&_ul]:space-y-1.5">
                {children}
            </div>
        </section>
    );
}

export default PolicyPage;
